import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../../contexts/AuthProvider";
import ModalUpdateProfile from "../../../../../Components/Modal/ModalInventory/ModalUpdateProfile";
import ModalUpdateCompany from "../../../../../Components/Modal/ModalInventory/ModalUpdateCompany";
import axios from "axios";

const AccountProfile = () => {
  const { user } = useContext(AuthContext);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

useEffect(() => {
  const fetchUserData = async () => {
    if (!user?.email) return;

    try {
      const token = localStorage.getItem("aircnc-token");
      const response = await fetch(
        `https://server-gs.vercel.app/user/${user.email}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setUserData(data);
      } else {
        const errorMessage = await response.json();
        setError(errorMessage.message || "Failed to fetch user data");
      }
    } catch (err) {
      setError("An error occurred while fetching user data");
    } finally {
      setLoading(false);
    }
  };

  // Fetch data when component mounts or when user.email changes
  fetchUserData();

}, [user?.email]);

  const [isDropdown, setIsDropdown] = useState(false);

  const openModalPersonal = () => {
    setIsDropdown(true);
  };

  const closeModalPersonal = () => {
    setIsDropdown(false);
  };

  const [isDropdownCompany, setIsDropdownCompany] = useState(false);

  const openModalPersonalCompany = () => {
    setIsDropdownCompany(true);
  };

  const closeModalPersonalCompany = () => {
    setIsDropdownCompany(false);
  };

  // company

  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/event-company-profile"
        );
        setData(response.data);
        setError(null); // Clear any previous errors
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    // Fetch data every second
    const intervalId = setInterval(fetchData, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="p-5 flex justify-between gap-5">
      <div className="w-[40%] h-[300px]  bg-white">
        <div className="flex flex-col">
          <div className="flex justify-between w-full px-5 pt-5 border-b border-b-gray-200 pb-4">
            <div>
              <h1 className="text-2xl font-roboto font-semibold text-gray-700">
                Profile
              </h1>
            </div>
            <button onClick={openModalPersonal}>
              <div className="rounded-full p-2 bg-gray-100">
                <img
                  className="w-6 h-6"
                  alt=""
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZD0iTTQ0Ni45NjcgMjIuMDQ4YTY4LjAyNCA2OC4wMjQgMCAwIDAtOTYuMDg5IDBMNDEuOTA5IDMzMS4wMTlhMTUuOTgxIDE1Ljk4MSAwIDAgMC00LjIyNCA3LjVMLjQ2MiA0ODkuOTkzQTE2IDE2IDAgMCAwIDE5LjMgNTA5LjQ2N2wxNTUuODU3LTMyLjg0M2ExNiAxNiAwIDAgMCA4LjAxNS00LjM0M2wzMDguOTctMzA4Ljk3YTY4LjA0NiA2OC4wNDYgMCAwIDAgMC05Ni4wODl6TTEzNy42ODIgMzk5LjEzNSAzNDkuNjEzIDE4Ny4ybDM2LjY5IDM2LjY5LTIxMS45MzEgMjExLjkzNXptLTU5LjMxOC01OS4zMTdMMjkwLjMgMTI3Ljg4N2wzNi42OSAzNi42OS0yMTEuOTM2IDIxMS45MzF6bTIzNC41NTgtMjM0LjU1OSAxOS43NjgtMTkuNzY4TDQyOC43IDE4MS41bC0xOS43NyAxOS43Njd6TTYyLjk3NyAzNjkuNjg1bDgwLjg0IDgwLjg0LTEwNi4yIDIyLjM4em00MDYuNTM2LTIyOS0xOC4xODggMTguMTg3LTk2LjAwNy05Ni4wMDggMTguMTg3LTE4LjE4OGEzNS45ODYgMzUuOTg2IDAgMCAxIDUwLjgzNCAwbDQ1LjE3NCA0NS4xNzRhMzYuMDQ2IDM2LjA0NiAwIDAgMSAwIDUwLjgzNHoiIGZpbGw9IiMwMDAwMDAiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiPjwvcGF0aD48L2c+PC9zdmc+"
                />
              </div>
            </button>
          </div>
          <div className="flex justify-between ">
            <div>
              {userData ? (
                <div className="p-5 flex flex-col gap-3">
                  <p className="text-xl font-roboto text-gray-600">
                    <strong>Name:</strong> {userData.name || "Not Provided"}
                  </p>
                  <p className="text-xl font-roboto text-gray-600">
                    <strong>Email:</strong> {userData.email}
                  </p>
                  <p className="text-xl font-roboto text-gray-600">
                    <strong>Role:</strong> {userData.role || "User"}
                  </p>
                  <p className="text-xl font-roboto text-gray-600">
                    <strong>Address:</strong> {userData.address || "User"}
                  </p>
                </div>
              ) : (
                <div>No user data found.</div>
              )}
            </div>

            <div className="w-36 h-36  m-5">
              <img
                class="w-36 h-36 object-cover rounded"
                src={userData.profilePicture}
                alt="Default avatar"
              ></img>
            </div>
          </div>
        </div>
      </div>
      <div className="w-[60%]  h-96 bg-white">
        <div className="flex justify-between w-full px-5 pt-5 border-b border-b-gray-200 pb-4">
          <div>
            <h1 className="text-2xl font-roboto font-semibold text-gray-700">
              Update your company profile
            </h1>
          </div>
          <button onClick={openModalPersonalCompany}>
            <div className="rounded-full p-2 bg-gray-100">
              <img
                className="w-6 h-6"
                alt=""
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZD0iTTQ0Ni45NjcgMjIuMDQ4YTY4LjAyNCA2OC4wMjQgMCAwIDAtOTYuMDg5IDBMNDEuOTA5IDMzMS4wMTlhMTUuOTgxIDE1Ljk4MSAwIDAgMC00LjIyNCA3LjVMLjQ2MiA0ODkuOTkzQTE2IDE2IDAgMCAwIDE5LjMgNTA5LjQ2N2wxNTUuODU3LTMyLjg0M2ExNiAxNiAwIDAgMCA4LjAxNS00LjM0M2wzMDguOTctMzA4Ljk3YTY4LjA0NiA2OC4wNDYgMCAwIDAgMC05Ni4wODl6TTEzNy42ODIgMzk5LjEzNSAzNDkuNjEzIDE4Ny4ybDM2LjY5IDM2LjY5LTIxMS45MzEgMjExLjkzNXptLTU5LjMxOC01OS4zMTdMMjkwLjMgMTI3Ljg4N2wzNi42OSAzNi42OS0yMTEuOTM2IDIxMS45MzF6bTIzNC41NTgtMjM0LjU1OSAxOS43NjgtMTkuNzY4TDQyOC43IDE4MS41bC0xOS43NyAxOS43Njd6TTYyLjk3NyAzNjkuNjg1bDgwLjg0IDgwLjg0LTEwNi4yIDIyLjM4em00MDYuNTM2LTIyOS0xOC4xODggMTguMTg3LTk2LjAwNy05Ni4wMDggMTguMTg3LTE4LjE4OGEzNS45ODYgMzUuOTg2IDAgMCAxIDUwLjgzNCAwbDQ1LjE3NCA0NS4xNzRhMzYuMDQ2IDM2LjA0NiAwIDAgMSAwIDUwLjgzNHoiIGZpbGw9IiMwMDAwMDAiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiPjwvcGF0aD48L2c+PC9zdmc+"
              />
            </div>
          </button>
        </div>
        <div className="flex flex-col">
          <div className="flex justify-between ">
            <div className="p-5 flex flex-col gap-3">
              <p className="text-xl font-roboto text-gray-600">
                <strong>Name:</strong> {data?.CompanyName || "N/A"}
              </p>
              <p className="text-xl font-roboto text-gray-600">
                <strong>Company ID:</strong> {data?.CompanyId || "N/A"}
              </p>
              <p className="text-xl font-roboto text-gray-600">
                <strong>Type:</strong> {data?.CompanyType || "Not specified"}
              </p>
              <p className="text-xl font-roboto text-gray-600">
                <strong>Description:</strong>{" "}
                {data?.CompanyDes || "No description available"}
              </p>
              <p className="text-xl font-roboto text-gray-600">
                <strong>Website:</strong>{" "}
                {data?.websiteUrl ? (
                  <a
                    href={data?.websiteUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {data?.websiteUrl}
                  </a>
                ) : (
                  "N/A"
                )}
              </p>
              <p className="text-xl font-roboto text-gray-600">
                <strong>Phone:</strong> {data?.phone || "N/A"}
              </p>
              <p className="text-xl font-roboto text-gray-600">
                <strong>Address:</strong> {data?.address || "N/A"}
              </p>
            </div>

            <div className="w-56 h-56  m-5">
              <img
                class="w-56 h-56 object-cover rounded"
                src={data?.CompanyLogo}
                alt="Default avatar"
              ></img>
            </div>
          </div>
        </div>
      </div>
      <ModalUpdateProfile
        isVisible={isDropdown}
        onClose={closeModalPersonal}
        user={user}
        closeModal={() => setIsDropdown(false)}
      ></ModalUpdateProfile>
      <ModalUpdateCompany
        isVisible={isDropdownCompany}
        onClose={closeModalPersonalCompany}
        closeModal={() => setIsDropdownCompany(false)}
      ></ModalUpdateCompany>
      
    </div>
  );
};

export default AccountProfile;
